import { Banner } from '../../components/banner/banner.component'
import { JuryMemberList } from '../juryMemberList/juryMemberList.component'
import { ProfileCard } from '../../components/profileCard/profileCard.component'
import { TrendingCardList } from '../trendingCardList/trendingCardList.component'
import { MyIdeasList } from '../myIdeasList/myIdeasList.component'
import logo from '../../assets/images/new-logo.png'

export const MyIdeas = () => {
    return (
        <>
            <div className="app-content content">
                <div className="content-overlay"></div>
                <div className="header-navbar-shadow">
                <img src={logo} className="d-none d-lg-block" alt="img" />
                </div>
                <div className="content-wrapper">
                    <div className="content-body">
                        <div className="row">
                            <div className="col-12 col-lg-9">
                                <div className="row">
                                <div className="col-lg-7">
                                    <Banner />
                                    </div>
                                    <div className='col-12 col-lg-5'>
                                    <JuryMemberList />
                                    </div>
                                </div>
                                <MyIdeasList />
                            </div>
                            <div className="col-12 col-lg-3">
                                <ProfileCard />
                                <TrendingCardList />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}